export default __webpack_public_path__ + "static/media/d1.39e56e88.png";